const updateTrainer = (state, action) => {
  if (state === undefined) {
    return {
      schedule: [],
      scheduleLoading: true,
      stateSchedule: [],
      loadingMain: true,
      loadingTraining: true,
      state_training_children: [],
      loadingStatus: false,
      training: {}
    };
  }

  switch (action.type) {
    case "SCHEDULE_TRAINER":
      return {
        ...state.trainer,
        schedule: action.payload
      };
    case "STATE_SCHEDULE_DATA":
      return {
        ...state.trainer,
        stateSchedule: action.payload
      };
    case "MAIN_LOADING":
      return {
        ...state.trainer,
        loadingMain: action.payload
      };
    case "SCHEDULE_LOADING":
      return {
        ...state.trainer,
        scheduleLoading: action.payload
      };
    case "TRAINING_LOADING":
      return {
        ...state.trainer,
        loadingTraining: action.payload
      };
    case "STATUS_LOADING":
      return {
        ...state.trainer,
        loadingStatus: action.payload
      };
    case "STATUS_TRAINING_CHILDREN":
      return {
        ...state.trainer,
        state_training_children: action.payload
      };
    case "TRAINING_LOADED":
      return {
        ...state.trainer,
        training: action.payload
      };
    default:
      return state.trainer;
  }
};

export default updateTrainer;
